import { useState } from 'react';

export default function Newsletter() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!email) {
      setStatus('error');
      setMessage('Please enter your email address');
      return;
    }

    setStatus('loading');

    try {
      const response = await fetch('https://readdy.ai/api/form/d6s1r16a739gopmlhsn0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({ email }).toString(),
      });

      if (response.ok) {
        setStatus('success');
        setMessage('You\'re in! Get ready for exclusive drops.');
        setEmail('');
      } else {
        setStatus('error');
        setMessage('Something went wrong. Please try again.');
      }
    } catch (error) {
      setStatus('error');
      setMessage('Connection error. Please try again.');
    }
  };

  return (
    <section className="py-36 px-8 bg-[#0A0A0A] relative overflow-hidden">
      {/* Noise Texture Overlay */}
      <div className="absolute inset-0 opacity-[0.03] bg-[url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMDAiIGhlaWdodD0iMzAwIj48ZmlsdGVyIGlkPSJhIiB4PSIwIiB5PSIwIj48ZmVUdXJidWxlbmNlIGJhc2VGcmVxdWVuY3k9Ii43NSIgc3RpdGNoVGlsZXM9InN0aXRjaCIgdHlwZT0iZnJhY3RhbE5vaXNlIi8+PGZlQ29sb3JNYXRyaXggdHlwZT0ic2F0dXJhdGUiIHZhbHVlcz0iMCIvPjwvZmlsdGVyPjxwYXRoIGQ9Ik0wIDBoMzAwdjMwMEgweiIgZmlsdGVyPSJ1cmwoI2EpIiBvcGFjaXR5PSIuMDUiLz48L3N2Zz4=')]"></div>

      <div className="max-w-[800px] mx-auto text-center relative z-10">
        {/* Next Drop Badge */}
        <div className="inline-flex items-center gap-2 border border-white/30 rounded-full px-6 py-2 mb-8">
          <span className="text-xs font-bold text-white tracking-wide">NEXT DROP: 03.15</span>
        </div>

        {/* Headline */}
        <h2 className="text-6xl md:text-7xl lg:text-8xl font-black text-white mb-6">
          Stay In The Loop
        </h2>
        
        <p className="text-lg text-gray-400 mb-12 max-w-xl mx-auto">
          Be first to know about new drops, restocks, and exclusive releases.
        </p>

        {/* Email Form */}
        <form onSubmit={handleSubmit} className="max-w-[600px] mx-auto" data-readdy-form id="newsletter-form">
          <div className="relative flex items-center">
            <input
              type="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="w-full h-14 bg-[#222222] text-white placeholder-gray-500 px-6 rounded-lg pr-36 focus:outline-none focus:ring-2 focus:ring-white/30 transition-all"
              disabled={status === 'loading'}
            />
            <button
              type="submit"
              disabled={status === 'loading'}
              className="absolute right-2 bg-white text-black px-8 py-3 rounded-md font-bold text-sm hover:scale-105 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap"
            >
              {status === 'loading' ? 'SUBSCRIBING...' : 'SUBSCRIBE'}
            </button>
          </div>
        </form>

        {/* Status Message */}
        {status !== 'idle' && (
          <p className={`mt-6 text-sm font-medium ${status === 'success' ? 'text-green-400' : 'text-red-400'}`}>
            {message}
          </p>
        )}

        {/* Social Proof */}
        <p className="text-xs text-gray-600 mt-8">
          Join 10,000+ members of the BillPlay community
        </p>
      </div>
    </section>
  );
}